import React from 'react';
import PropTypes from 'prop-types';
import { comma } from '../common/HelperFunctions';

const ForthcomingItem = ({
  id,
  permalink,
  onInterestModal,
  street,
  town,
  county,
  thumbnail,
  name,
  description,
  dateavailable,
}) => {
  const address = comma(street, town, county);

  return (
    <div className="development-item col-md-4 col-sm-6 col-lg-4">
      <div className="shadow">
        <div>
          <img
            className="img-responsive"
            src={
              thumbnail
                ? `/uploads/developments/${permalink}/thumbnail.jpg`
                : '/images/development_tb.jpg'
            }
            alt=""
          />
        </div>
        <div className="container-fluid forthcoming-container">
          <h2 className="text-primary">
            <a style={{ cursor: 'pointer' }} onClick={() => onInterestModal(id, name)}>
              {name}
            </a>
          </h2>
          <h4 className="address">{address}</h4>
          <p>{description}</p>
          {dateavailable && (
            <p className="available-from">
              <strong>Available From: </strong>
              <em>{dateavailable}</em>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

ForthcomingItem.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  town: PropTypes.string.isRequired,
  county: PropTypes.string.isRequired,
  permalink: PropTypes.string.isRequired,
  thumbnail: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  dateavailable: PropTypes.string.isRequired,
  onInterestModal: PropTypes.func.isRequired,
};

export default ForthcomingItem;
